"use client"
import styled from "@emotion/styled"
import { useState } from "react"
import { useInView } from "react-intersection-observer"
import {
  AnimatedTypography,
  transitionDelayTime,
  TransitionUp,
  useInViewConfig,
} from "ui"
import Container from "ui/Container"
import { extractProperty, ravKavTypes, replaceRichTextLinks } from "utils"
import AccordionItemComp from "../Common/FaqItem"

const AccordionArray = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  /* max-width: 1040px; */
  gap: 24px;
  padding-top: 24px;
`

const OuterContainer = styled.div`
  width: 100%;
  padding-top: 32px;
  padding-bottom: 48px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
    padding-bottom: 64px;
  }
`
const StyledTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
type Props = {
  data: any
}
type UndStr = string | undefined

const SimpleAccordion = ({ data }: Props) => {
  const title = extractProperty(data, "title") as UndStr
  const description = extractProperty(data, "description") as UndStr
  const itemsListBlock = extractProperty(data, "itemsList") || []
  const itemsList = itemsListBlock.map((el: any) => ({
    question: extractProperty(el, "question"),
    content: extractProperty(el, "answer"),
  })) as any
  const { ref, inView } = useInView(useInViewConfig)
  const [expandedIndex, setExpandedIndex] = useState<number>(-1)

  const handleChange =
    (index: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      // If expanding a new item, set its index; if collapsing, set to -1 (none)
      setExpandedIndex(isExpanded ? index : -1)
      const clickedItem = itemsList[index]
      ravKavTypes(clickedItem.question, isExpanded ? "פתיחה" : "סגירה")
    }

  return (
    <OuterContainer ref={ref}>
      <Container paddingMobile>
        <StyledTextBox>
          <AnimatedTypography variant="h3" component="h2" $inview={inView}>
            {title}
          </AnimatedTypography>
          {description && (
            <AnimatedTypography
              variant="body1"
              $inview={inView}
              component="div"
              dangerouslySetInnerHTML={{
                __html: replaceRichTextLinks(description),
              }}
            ></AnimatedTypography>
          )}
        </StyledTextBox>
        <AccordionArray>
          {itemsList.map((item: any, i: number) => (
            <TransitionUp
              $inView={inView}
              $delay={transitionDelayTime * 0.5 * i}
              key={i}
            >
              <AccordionItemComp
                key={i}
                content={item.content}
                title={item.question}
                expanded={expandedIndex === i}
                onChange={handleChange(i)}
              />
            </TransitionUp>
          ))}
        </AccordionArray>
      </Container>
    </OuterContainer>
  )
}

export default SimpleAccordion
